import { faker } from '@faker-js/faker'
import { GetPayablesSummaryResponseBody, Payable } from '../types'

export const generatePayablesSummaryResponse: (
    limit: number,
    totalItems: number
) => GetPayablesSummaryResponseBody = (limit, totalItems) => {
    const items = Array.from(new Array(limit)).map(() => {
        const payable: Payable = {
            invoiceId: faker.string.uuid(),
            invoiceNo: faker.string.uuid(),
            providerName: faker.lorem.words(2),
            billDate: Math.floor(faker.date.anytime().getTime() / 1000),
            dueDate: Math.floor(faker.date.anytime().getTime() / 1000),
            billsCount: faker.number.int({
                min: 1,
                max: 5,
            }),
            totalInvoiced: {
                value: faker.number.int({
                    min: 1000,
                    max: 5000,
                }),
                unit: 'USD',
            },
            charges: {
                value: faker.number.int({
                    min: 100,
                    max: 500,
                }),
                unit: 'USD',
            },
        }

        return payable
    })

    return {
        items,
        totalItems,
    }
}
